import type { ComponentPropsWithRef, ReactNode } from "react";
import { forwardRef } from "react";
import { BlockSection } from "@/react/components/shared/BuilderUI/BlockSection";
import { useTopBlockStyles } from "../../../Hooks/useTopBlockStyles";
import type { StyleValue } from "../../../StyleValue.types";
import { salesPrimaryBlockDefaultStyles } from "../constants";

export interface SalesBlock1Props extends ComponentPropsWithRef<"div"> {
  badges?: ReactNode;
  buttons?: ReactNode;
  leftContent?: ReactNode;
  rightContent?: ReactNode;
  styles?: Record<string, StyleValue>;
  userSatisfaction?: ReactNode;
}

export const SalesBlock1 = forwardRef<HTMLDivElement, SalesBlock1Props>(
  (
    {
      leftContent,
      buttons,
      rightContent,
      styles,
      className,
      badges,
      userSatisfaction,
      ...rest
    },
    ref,
  ) => {
    const { backgroundStyles, paddingStyles, marginStyles } = useTopBlockStyles(
      {
        styles,
        defaultStyles: salesPrimaryBlockDefaultStyles,
      },
    );

    return (
      <BlockSection ref={ref} className={className} {...rest}>
        <BlockSection.Background style={backgroundStyles}>
          <BlockSection.Container>
            <BlockSection.Content
              style={{
                ...paddingStyles,
                ...marginStyles,
              }}
            >
              <div className="wb-grid md:wb-grid-cols-2 md:wb-gap-12 wb-gap-8">
                <div className="wb-flex wb-flex-col wb-gap-4 md:wb-gap-6 wb-text-center md:wb-text-left">
                  {badges}
                  {leftContent}
                  <BlockSection.NestedBlock className="wb-flex wb-flex-col wb-items-center wb-gap-3 md:wb-flex-row">
                    {buttons}
                  </BlockSection.NestedBlock>
                  {userSatisfaction}
                </div>
                <BlockSection.NestedBlock className="wb-mx-auto wb-relative">
                  {rightContent}
                </BlockSection.NestedBlock>
              </div>
            </BlockSection.Content>
          </BlockSection.Container>
        </BlockSection.Background>
      </BlockSection>
    );
  },
);

SalesBlock1.displayName = "SalesBlock1";
